import React, { Component } from "react";
import { Button, Switch, Tooltip } from "antd";
import i18n from "i18next";

import { code } from "../../constants";
import { ExpandOutlined } from "@ant-design/icons";
import Joystick from "./Joystick";

import { connect } from "react-redux";

class Footer extends Component {
  componentDidMount() {
    const { canvasRef } = this.props;
    this.waitForCanvasRender(canvasRef);
  }

  componentWillUnmount() {
    const { canvasRef } = this.props;
    this.detachEventListener(canvasRef);
  }

  waitForCanvasRender = (canvas) => {
    setTimeout(() => {
      if (canvas) {
        this.attachEventListener(canvas);
        return;
      }
      const { canvasRef } = this.props;
      this.waitForCanvasRender(canvasRef);
    }, 5);
  };

  attachEventListener = (canvasRef) => {
    canvasRef.canvas.wrapperEl.addEventListener(
      "keydown",
      this.events.keydown,
      false
    );
  };

  detachEventListener = (canvasRef) => {
    canvasRef.canvas.wrapperEl.removeEventListener(
      "keydown",
      this.events.keydown
    );
  };

  events = {
    keydown: (e) => {
      if (this.props.canvasRef.canvas.wrapperEl !== document.activeElement)
        return false;
      if (e.code === code.KEY_Q) this.handlers.selection();
      if (e.code === code.KEY_W) this.handlers.grab();
    },
  };

  render() {
    const { canvasRef, zoomRatio } = this.props;
    if (!canvasRef) return null;
    const zoomValue = parseInt((zoomRatio * 100).toFixed(2), 10);
    return (
      <>
        {this.props.zoneActive === false && <>
          <div className="map-editor-footer-toolbar-zoom">
            <Joystick canvasRef={canvasRef} />
            <Button.Group>
              <Tooltip
                title={` ${i18n.t("mapeditor.actions.zoom-out")}`}
                placement="top"
              >
                <Button
                  size="small"
                  onClick={() => {
                    canvasRef.handler.zoomHandler.zoomOut();
                  }}
                >
                  <span className="icon-zoom-out"></span>
                </Button>
              </Tooltip>
              <Tooltip
                title={` ${i18n.t("mapeditor.actions.one-to-one")}`}
                placement="top"
              >
                <Button
                  size="small"
                  onClick={() => {
                    canvasRef.handler.zoomHandler.zoomOneToOne();
                  }}
                >{`${zoomValue}%`}</Button>
              </Tooltip>
              <Tooltip
                title={` ${i18n.t("mapeditor.actions.fit")}`}
                placement="top"
              >
                <Button
                  size="small"
                  onClick={() => {
                    canvasRef.handler.zoomHandler.zoomToFit();
                  }}
                >
                  <ExpandOutlined />
                </Button>
              </Tooltip>
              <Tooltip
                title={` ${i18n.t("mapeditor.actions.zoom-in")}`}
                placement="top"
              >
                <Button
                  size="small"
                  onClick={() => {
                    canvasRef.handler.zoomHandler.zoomIn();
                  }}
                >
                  <span className="icon-icon-zoom-in"></span>
                </Button>
              </Tooltip>
            </Button.Group>
          </div>
        </>
        }
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    zoneActive: state.properties.zoneActive,
  };
};

export default connect(mapStateToProps)(Footer);
